import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VersionService {
    constructor(private http: HttpClient) {}

    url = `https://${window.location.host}/api/v0.5/version`;

    public getAppVersion(): Observable<Object> {
        return this.http.get(this.url);
    }

    applicationInsightsInstrumentationKey: Observable<string>;

    public getApplicationInsightsInstrumentationKey(): Observable<string> {
        let rc: Observable<string>;

        if (this.applicationInsightsInstrumentationKey) {
            rc = this.applicationInsightsInstrumentationKey;
        } else {
            rc = this.applicationInsightsInstrumentationKey = this.http.get<string>(
                `${this.url}/ApplicationInsightsInstrumentationKey`
            );
        }
        //todo: add error pipe
        return rc;
    }

    public getKnowledgeBaseUrl(): Observable<any> {
        return this.http.get(`${this.url}/kb`);
    }

    public getClientLoanMetrics(): Observable<any> {
        return this.http.get(`${this.url}/metrics/loan`);
    }
}
